import { message } from 'antd';
import { marketPlaceUI, researchUI } from '../../api';
import { ERROR_MSG } from '../Helper/Constant';
import { MarketPlaceUIFunction } from './MarketPlaceConstant';

export const getMarketPlaceInitData = async () => {
    const result = await marketPlaceUI({
        function: MarketPlaceUIFunction.MARKET_PLACE,
        getType: MarketPlaceUIFunction.MARKET_PLACE_INIT,
    });
    if (result?.success === 1) {
        return result.result;
    } else {
        return false;
    }
};

export const validateMarketPlace = async (data, marketName, type, connectedAppId = 0) => {
    const result = await marketPlaceUI({
        function: MarketPlaceUIFunction.MARKET_PLACE,
        getType: MarketPlaceUIFunction.VALIDATE_MARKET_PLACE,
        data: data,
        marketName: marketName,
        type: type,
        connectedAppId,
    });
    if (result.success === 1) {
        return true;
    } else {
        message.error(result.result.msg);
        return false;
    }
};

export const addMarketPlace = async (data, type) => {
    const result = await marketPlaceUI({
        function: MarketPlaceUIFunction.MARKET_PLACE,
        getType: MarketPlaceUIFunction.ADD_MARKET_PLACE,
        data,
        type,
    });
    if (result.success === 1) {
        return result.result;
    } else {
        message.error(result.result.msg);
        return false;
    }
};

export const searchMarketPlace = async (data, marketName, type) => {
    const result = await marketPlaceUI({
        function: MarketPlaceUIFunction.MARKET_PLACE,
        getType: MarketPlaceUIFunction.SEARCH_MARKET_PLACE,
        searchText: data,
        marketName: marketName,
        type,
    });
    if (result.success === 1) {
        return result.result;
    } else {
        message.error(ERROR_MSG.GENERAL_ERROR);
        return false;
    }
};

export const getPermissionByConnectedApps = async (connectedAppId) => {
    const result = await marketPlaceUI({
        function: MarketPlaceUIFunction.MARKET_PLACE,
        getType: MarketPlaceUIFunction.GET_PERMISSION_BY_CONNECTED_APPS,
        connectedAppId,
    });
    if (result.success === 1) {
        return result.result;
    } else {
        message.error(ERROR_MSG.GENERAL_ERROR);
        return false;
    }
};

export const searchSaasApp = async (searchText) => {
    const result = await researchUI({
        function: MarketPlaceUIFunction.COMMON_FUNCTION,
        reqType: MarketPlaceUIFunction.SEARCH_APP,
        searchText,
    }).catch(() => {
        return false;
    });
    if (result.success === 1) {
        return result.data;
    } else {
        message.error(ERROR_MSG.GENERAL_ERROR);
        return false;
    }
};

export const modifyPermission = async (connected_app_id, permission_id, operationType) => {
    const result = await marketPlaceUI({
        function: MarketPlaceUIFunction.MARKET_PLACE,
        getType: MarketPlaceUIFunction.CONNECTED_APP_PERMISSION,
        data: { connected_app_id, permission_id },
        operationType,
    });
    if (result.success === 1) {
        return result.result;
    } else {
        message.error(ERROR_MSG.GENERAL_ERROR);
        return false;
    }
};

export const modifyConnectedApps = async (connected_app_id, operationType, data = {}) => {
    const result = await marketPlaceUI({
        function: MarketPlaceUIFunction.MARKET_PLACE,
        getType: MarketPlaceUIFunction.CONNECTED_APPS,
        data: { connected_app_id, ...data },
        operationType,
    });
    if (result.success === 1) {
        return result.result;
    } else {
        message.error(ERROR_MSG.GENERAL_ERROR);
        return false;
    }
};

export const connectedAppsWithoutPermissions = async (marketName) => {
    const result = await marketPlaceUI({
        function: MarketPlaceUIFunction.MARKET_PLACE,
        getType: MarketPlaceUIFunction.CONNECTED_APPS_WITHOUT_PERMISSIONS,
        marketName: marketName,
    });
    if (result.success === 1) {
        return result.result;
    } else {
        message.error(ERROR_MSG.GENERAL_ERROR);
        return false;
    }
};

export const saveEditConnectedApp = async (data, marketName, connectedAppId) => {
    const result = await marketPlaceUI({
        function: MarketPlaceUIFunction.MARKET_PLACE,
        getType: MarketPlaceUIFunction.EDIT_CONNECTED_APP,
        marketName: marketName,
        data,
        connectedAppId,
    });
    if (result.success === 1) {
        return result.result;
    } else {
        message.error(ERROR_MSG.GENERAL_ERROR);
        return false;
    }
};

export const updateRiskLevels = async () => {
    const result = await marketPlaceUI({
        function: MarketPlaceUIFunction.MARKET_PLACE,
        getType: MarketPlaceUIFunction.UPDATE_RISK_LEVELS,
    });
    if (result.success === 0) {
        message.error(ERROR_MSG.GENERAL_ERROR);
        return false;
    } else {
        return result.result;
    }
};

export const checkLogo = async (marketName) => {
    const result = await marketPlaceUI({
        function: MarketPlaceUIFunction.MARKET_PLACE,
        getType: MarketPlaceUIFunction.CHECK_LOGO,
        marketName,
    });
    if (result.success === 1) {
        return result.result;
    } else {
        message.error(ERROR_MSG.GENERAL_ERROR);
        return false;
    }
};